import React, { useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const Home = ({ visitCookie }) => {
  const navigate = useNavigate();

  /* React hook that will be executed on creation and every time the dependencies update. */
  useEffect(() => {
    /**
     * Method to redirect directly to the onboarding section as landingpage.
     */
    const autoRedirectToOnboarding = () => {
      navigate("/onboarding");
    };

    /**
     * Method to redirect directly to the search section as landingpage.
     */
    const autoRedirectToSearch = () => {
      navigate("/search");
    };

    // Simple redirect logic
    if (visitCookie.firstVisit) autoRedirectToSearch();
    else autoRedirectToOnboarding();
  }, [navigate, visitCookie.firstVisit]);

  return (
    /* Initial transition to be applied to the webpage. */
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: 0.3 } }}
    ></motion.div>
  );
};

export default Home;
